import { AnalyticsPlugin } from 'analytics';
import isEmpty from 'lodash/isEmpty';

import { TrackingPixelVendor } from '../enums/TrackingPixelVendor';
import { TrackingPixel } from '../types/TrackingPixel';
import { TrackingPixelPluginPayload } from '../types/TrackingPixelPluginPayload';

export const createTrackingPixelPlugin = (
  vendor: TrackingPixelVendor,
  send: (pixels: TrackingPixel[], payload: TrackingPixelPluginPayload) => void,
): AnalyticsPlugin => ({
  name: vendor,
  track: ({ payload }: { payload: TrackingPixelPluginPayload }): void => {
    const pixels = (payload.options?.pixels ?? []).filter(
      (pixel): boolean => pixel.vendor === vendor,
    );

    if (isEmpty(pixels)) {
      return;
    }

    try {
      send(pixels, payload);
    } catch (error: unknown) {
      // a throw inside @analytics is an unhandled rejection, and it skips the
      // plugins after this one, Google Tag Manager included
      console.error(error);
    }
  },
});
